import React from 'react';
import { Box, TextField, Button } from '@mui/material';
import AppSelect from 'components/AppSelect';
import { JiraFilter } from '../types';
import { jiraStatuses } from '../utils/jiraStatuses';

interface JiraFiltersProps {
  filter: JiraFilter;
  onChange: (filter: JiraFilter) => void;
  onApply: () => void;
  onSaveSelected?: () => void;
  isSavingSelected?: boolean;
  hasSelectedIssues?: boolean;
}

const JiraFilters: React.FC<JiraFiltersProps> = ({
  filter,
  onChange,
  onApply,
  onSaveSelected,
  isSavingSelected,
  hasSelectedIssues,
}) => {
  const handleChange = (field: keyof JiraFilter, value: string) => {
    onChange({
      ...filter,
      [field]: value,
    });
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
      <TextField
        label="Ключ проекта"
        value={filter.projectKey || ''}
        onChange={(e) => handleChange('projectKey', e.target.value)}
        size="small"
        sx={{ minWidth: 150 }}
        disabled
      />
      <AppSelect
        options={jiraStatuses}
        getOptionLabel={(option) => option.label}
        value={jiraStatuses.find((s) => s.value === filter.status) || null}
        onChange={(_event, newValue) => {
          handleChange('status', newValue?.value || '');
        }}
        size="small"
        sx={{ minWidth: 250 }}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        label="Статус"
        textFieldProps={{ placeholder: 'Выберите статус' }}
      />
      <TextField
        label="Автор"
        value={filter.reporter || ''}
        onChange={(e) => handleChange('reporter', e.target.value)}
        size="small"
        sx={{ minWidth: 150 }}
      />
      <TextField
        label="Исполнитель"
        value={filter.assignee || ''}
        onChange={(e) => handleChange('assignee', e.target.value)}
        size="small"
        sx={{ minWidth: 150 }}
      />
      <Button variant="contained" onClick={onApply} sx={{ minWidth: 100 }}>
        Искать
      </Button>
      {hasSelectedIssues && onSaveSelected && (
        <Button
          variant="outlined"
          onClick={onSaveSelected}
          disabled={isSavingSelected}
          sx={{ minWidth: 100 }}
        >
          {isSavingSelected ? 'Сохранение...' : 'Сохранить в контекст'}
        </Button>
      )}
    </Box>
  );
};

export default JiraFilters;
